__turbopack_context__.v({
  "howItWorksSection": "how-it-works-section-module-scss-module__ikuIsW__howItWorksSection",
  "howItWorksSection_content": "how-it-works-section-module-scss-module__ikuIsW__howItWorksSection_content",
  "howItWorksSection_description": "how-it-works-section-module-scss-module__ikuIsW__howItWorksSection_description",
  "howItWorksSection_icon": "how-it-works-section-module-scss-module__ikuIsW__howItWorksSection_icon",
});
